import { useEffect, useState } from 'react';
import { loadFamilyPortalView } from '../data/familyPortal';

// The Family Portal's view of one studio's family (#772), asked of the
// server (`familyPortalView`, functions/portal/view.js) — the only way a
// family reads anything of a studio. Online only, and asked again by `retry`
// or by choosing another family; the portal has no offline mode (#543 §4).
//
// `{ view, error, loading, retry }`: `error` is `{ message, refusal }`, the
// core's sentence and its code (`no_access`, `unavailable`, `closed`,
// `failed`). An answer for a family other than the one now chosen is never
// returned, so switching families never shows the last one's lessons.
export function usePortalView(choice) {
  const key = choice?.key ?? null;
  const studioUid = choice?.studioUid ?? null;
  const familyId = choice?.familyId ?? null;
  const [state, setState] = useState({ key: null, view: null, error: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!key) return undefined;
    let live = true;
    setState((prev) => (prev.key === key ? { key, view: null, error: null } : prev));
    loadFamilyPortalView({ studioUid, familyId }).then(
      (view) => { if (live) setState({ key, view, error: null }); },
      (err) => {
        if (live) setState({ key, view: null, error: { message: err?.message || String(err), refusal: err?.refusal || null } });
      },
    );
    return () => { live = false; };
  }, [key, studioUid, familyId, attempt]);

  const mine = state.key === key ? state : { view: null, error: null };
  return {
    view: mine.view,
    error: mine.error,
    loading: Boolean(key) && !mine.view && !mine.error,
    retry: () => setAttempt((n) => n + 1),
  };
}
